<template>
  <div class="bc-wrapper">
    <span
      v-for="(singleRoute, index) in bcItems"
      :key="index"
      class="bc-sigle-wrapper"
    >
      <router-link
        v-if="index !== Object.values(bcItems).length - 1"
        :to="createPath(singleRoute)"
        class="bc-single-item"
      >
        <span class="bc-span">{{ titleToUppercase(singleRoute.name) }}</span>
      </router-link>
      <span v-else class="bc-span">{{
        titleToUppercase(singleRoute.name)
      }}</span>
      {{ index !== Object.values(bcItems).length - 1 ? ">" : "" }}
    </span>
  </div>
</template>

<script>
import CheckAPI from '@/api'

export default {
  name: "BreadCrumbs",
  components: {},
  data: function() {
    return {
      bcItems: []
    };
  },
  methods: {
      
    titleToUppercase(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    createPath(bcSingleItem) {
      switch (bcSingleItem.type) {
        case "COURSE":
          return {
            name: "Lessons"
          };
        case "LESSON":
          return {
            name: "Units"
          };
        case "UNIT":
          return {
            name: "Elements"
          };
        case "ELEMENT":
          return {
            name: "criteria-view"
          };
      }
      return `${bcSingleItem}`;
    },

    clean(targetObject) {
      for (const propName in targetObject) {
        if (
          targetObject[propName] === null ||
          targetObject[propName] === undefined
        ) {
          delete targetObject[propName];
        }
      }
      return targetObject;
    },

    async getBC() {
      const { params } = this.$route;
      const response = await CheckAPI.getBC(params)
      this.bcItems = this.clean(response.data.data.breadcrumbs);
    }
  },
  mounted() {
    this.getBC();
  },
  watch: {
    $route: {
      deep: true,
      handler: function() {
        this.bcItems = [];
        this.getBC();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bc-wrapper {
  display: flex;
  flex: 0 0 100%;
  padding-left: 0;
  width: 100%;
  word-break: break-word;
}

.bc-sigle-wrapper {
  margin-right: 5px;
  color: black;
  margin-left: 5px;
}

.bc-span {
  vertical-align: baseline;
  font-family: ProductSans;
  font-size: 1em;
  color: #000000;
  text-decoration: none;
}

.bc-single-item {
  display: inline-flex;
  cursor: pointer;
  font-family: ProductSans;
  font-size: 1em;
  color: #000000;
  text-decoration: none;
}
</style>